import React from "react";

const SleepIcon = () => {
  return (
    // <svg width="30" height="30">
    //   <img src={sleepIcon} width="30" height="30" alt="moon icon" />
    // </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      stroke="rgba(200,200,200)"
      viewBox="0 0 256 256"
    >
      <path
        fill="none"
        width="30"
        height="30"
        stroke="rgba(200,200,200)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M216.662 152.65A92.032 92.032 0 01103.35 39.338h.003A92.014 92.014 0 10216.66 152.647z"
      ></path>
    </svg>
  );
};

export default SleepIcon;
